import { useEffect } from 'react';

type EffectFunction = () => void;

const useMount = (effect: EffectFunction): void => {
  useEffect(() => {
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array means execution occurs on mount
};

export default useMount;
